import { useEffect, useState } from 'react'
import { recordError } from '../../utils/logService';
import { Button, Modal } from 'antd';
import logService from '../../services/applicationErrorService';
import moment from 'moment';

import ApplicationErrorDetails from './ApplicationErrorDetails';

const ViewApplicationLogs = (props) => {

    const [logDetails, setLogDetails] = useState({});
    const key  = props.record?.id;
    useEffect(() => {
        prePopulate();
    }, [props.record])
    
    const prePopulate = async () => {
        try {
            if (key) {
                const response = await logService.getErrorDetails(key);

                if (response && response.status === 200) {
                    const { data } = response;
                    const name = props.tabList.find(tab => tab.key === data.appName);
                    const _logDetails = {
                        appName: name?.label || data.appName,
                        browserName: data.browserName,
                        errorTime: moment(data.errorTime).format("DD MMM YYYY, HH:mm"),
                        message: data.message,
                        mobile: data.mobile,
                        stackTrace: data.stackTrace
                    }
                    setLogDetails(_logDetails);

                }
            }
        } catch (error) {
            recordError(error);
        }
    };

    const closeModal = () => {
        props.setVisible(false);
    };
    return (
        <>

            <Modal
                key="modal-edit-user"
                forceRender
                title="Application log Detailed View"
                open={props.record}
                closable={false}
                keyboard={false}
                maskClosable={false}
                width="900px"
                footer={[
                    <div className="modal-footer-buttons" key="modal-footer">
                    
                            <Button
                                style={{ marginLeft: 10 }}
                                onClick={closeModal}
                            >
                                Cancel
                            </Button>
                        
                    </div>,
                ]}
            >
                <ApplicationErrorDetails data={logDetails}/>
            </Modal>
         

        </>
    )
}

export default ViewApplicationLogs